<template>
	<div class="headNav">
		<div class="head">
			<div class="mainContent">
				<img @click="getActive('Inicio')" class="logo" src="@/assets/image/logo.webp" alt="" />
				<ul class="nav">
					<li :class="activeNav == 'Inicio' ? 'active' : ''">
						<a @click="getActive('Inicio')">Inicio</a>
					</li>
					<li>
						<a @click="onJump()">Sobre nosotros</a>
					</li>
					<li :class="activeNav == 'FAQ' ? 'active' : ''">
						<a @click="getActive('FAQ')">FAQ</a>
					</li>
					<li :class="activeNav == 'Aviso' ? 'active' : ''">
						<a @click="getActive('Aviso')">Aviso de privacidad</a>
					</li>
					<li>
						<a @click="goUse">TÉRMINOS Y CONDICIONES</a>
					</li>
				</ul>
			</div>
		</div>

		<!-- <div class="broadcast-content-bg">
			<div class="broadcast-content">
				<div class="content-wrapper">
					<span class="content">
						Debido a problemas en la red, la APP no está disponible temporalmente para su descarga. Prevemos que el
						servicio se restablezca en un plazo de 24 horas. Lamentamos las molestias ocasionadas.
					</span>
				</div>
			</div>
		</div> -->
	</div>
</template>

<script>
	import './scss/nav.scss'

	export default {
		name: 'headNav',
		props: ['activeNav'],
		data() {
			return {
				// active: "Inicio",
				value: 0,
			}
		},
		created() {
			console.log(this.activeNav)
			// this.active = this.activeNav;
			// console.log(nav, this.active);
			// if (nav) {
			//   this.active = nav;
			// } else {
			//   localStorage.setItem('activeNav', "Inicio");
			// }
		},
		methods: {
			goUse() {
				window.open('https://www.dinerbacano.co/h5/use.html')
			},
			getActive(val) {
				let url = ''
				switch (val) {
					case 'Inicio':
						url = '/home'
						break
					case 'Aviso':
						url = '/notice?value=1'
						break
					case 'FAQ':
						url = '/help'
						break
					case 'loan':
						url = '/loan'
						break
				}
				this.$router.push(url)
			},

			onJump() {
				this.value++
				this.$router.push(`/home?value=${this.value}`)
			},
		},
	}
</script>

<style></style>
